import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { useState, useEffect } from "react";

const containerStyle = {
  width: "100%",
  height: "220px",
  borderRadius: "12px",
};

const center = {
  lat: -33.8688, // default (Sydney example)
  lng: 151.2093,
};

export default function GeoRiskMap({
  currentLocation,
  lastLoginLocation,
  addressString,
}) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const [resolvedLocation, setResolvedLocation] = useState(null);

  // If currentLocation isn't provided, attempt to geocode the addressString
  useEffect(() => {
    if (!isLoaded) return;

    const hasCoords =
      currentLocation &&
      typeof currentLocation.lat === "number" &&
      typeof currentLocation.lng === "number";

    if (hasCoords) {
      setResolvedLocation(currentLocation);
      return;
    }

    if (addressString && window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: addressString }, (results, status) => {
        if (status === "OK" && results[0]) {
          const loc = results[0].geometry.location;
          setResolvedLocation({ lat: loc.lat(), lng: loc.lng() });
        } else {
          // fallback to null (component will use default center)
          setResolvedLocation(null);
        }
      });
    } else {
      setResolvedLocation(null);
    }
  }, [isLoaded, currentLocation, addressString]);

  if (!isLoaded) {
    return (
      <div className="h-[220px] flex items-center justify-center text-xs text-gray-500 bg-gray-100 rounded-xl">
        Loading Geo Intelligence Map...
      </div>
    );
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={resolvedLocation || currentLocation || center}
      zoom={resolvedLocation || currentLocation ? 12 : 4}
      options={{
        disableDefaultUI: true,
        zoomControl: true,
        styles: [
          {
            featureType: "all",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }],
          },
        ],
      }}
    >
      {/* CURRENT LOCATION (GREEN) */}
      {currentLocation && (
        <Marker
          position={currentLocation}
          label={{
            text: "Provided Location",
            color: "#16a34a",
            fontSize: "10px",
            fontWeight: "bold",
          }}
          icon={{
            url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
          }}
        />
      )}

      {/* LAST LOGIN LOCATION (RED) */}
      {lastLoginLocation && (
        <Marker
          position={lastLoginLocation}
          label={{
            text: "LAST LOGIN",
            color: "#dc2626",
            fontSize: "10px",
            fontWeight: "bold",
          }}
          icon={{
            url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
          }}
        />
      )}
    </GoogleMap>
  );
}